import { Component, Input, OnInit, OnChanges } from 'angular-ts-decorators';
import { SwChange } from '@core/app/scripts/classes/sw-change';
import { Country } from '@core/app/scripts/services/country';

/**
 * Component to display all countries in the localized name, and allow user
 * user to choose one.

 * # Attributes:
 * * sw-change - callback function, is called with the new value provided in `value`
 * * sw-value - accept the value to be set, one way binding
 *
 * # Deprecated attributes:
 * * sw-model - two ways binding for the value
 *
 * ## Usage
 * <pre>
 *   <sw-country-picker sw-value="modelToUpdate" sw-read-only="[true|false]" sw-change="callback(value)"></sw-country-picker>
 * </pre>
 */
@Component({
  selector: 'swCountryPicker',
  template: require('./sw-country-picker.html').default,
})
export class SwCountryPickerComponent
  extends SwChange
  implements OnInit, OnChanges
{
  @Input() swValue: any;
  @Input() swReadOnly: any;

  swModel: () => any;

  countryList: object[];

  constructor(private country: Country) {
    'ngInject';

    super();
  }

  ngOnInit() {
    this.countryList = this.country.getCountryInfoList();
  }

  ngOnChanges() {
    this.swModel = this.swValue;
  }
}
